// store/auth.js
import axios from '../axios';

const authModule = {
  state: () => ({
    isAuthenticated: !!localStorage.getItem('access_token'),
  }),
  getters: {
    isAuthenticated: state => state.isAuthenticated,
  },
  mutations: {
    SET_AUTHENTICATED(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated;
    },
  },
  actions: {
    async login({ commit }, user) {
      // 模拟登录逻辑，实际应用中应通过 API 获取用户信息
      commit('SET_USER', user, { root: true });  // 设置用户信息到根 store 的 user 模块
      commit('SET_AUTHENTICATED', true);
    },
    async logout({ commit }) {
      try {
        // const refreshToken = localStorage.getItem('refresh_token');
        // await axios.post('web/userauth/logout/', { refresh_token: refreshToken });
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        commit('SET_USER', null, { root: true });  // 清除用户信息
        commit('SET_AUTHENTICATED', false);
        console.log(23423423423)
      } catch (error) {
        console.error('Logout failed:', error);
        throw error;
      }
    }
  },
};

export default authModule;
